import { useEffect, useRef, useState } from 'react';
import moment from 'moment';

const ExpoTime = ({
  date,
  status
}) => {
  const getTime = () => {
    const momentTime = moment.utc(date).local();
    const currentTime = moment();
    const diffTime = currentTime.diff(momentTime, 'seconds');
    const momentDate = momentTime.format('YYYY-MM-DD');
    let time;
    if (currentTime > momentTime || status) {
    time = moment(momentDate).startOf('day')
      .seconds(diffTime)
        .format('mm:ss');
    } else {
      time = moment(momentDate).startOf('day')
        .seconds(momentTime.diff(currentTime, 'seconds'))
        .format('mm:ss')
      time = " - " + time;
    }   
    return [time];
  };
  const intervalId = useRef(null);
  const callbackRef = useRef(getTime);
  const [Time, setTime] = useState(() => {
    const [time] = callbackRef.current();
    return time;
  });
  useEffect(() => {
    if (date) {
      if (intervalId.current) {
        clearInterval(intervalId.current);
      }
      callbackRef.current = getTime;
      intervalId.current = setInterval(() => {
        const [time] = callbackRef.current();
        setTime(time);
      }, 1000);
    } else {
      setTime('00:00');
    }
    return () => {
      if (intervalId.current) {
        clearInterval(intervalId.current);
        setTime('00:00');
      }
    };
  }, [date]);
  return Time;
};



export default ExpoTime;
